async function initializeSwiper(swiperSelectorString, options) {
  const swiperCollection = document.querySelectorAll(swiperSelectorString);
  console.log({ swiperCollection, swiperSelectorString });

  console.log({ options }, `${swiperSelectorString} .swiper-button-next`);
  if (swiperCollection.length > 0) {
    const { Swiper } = await import("swiper");
    const { Navigation, Autoplay } = await import("swiper/modules");
    await import("/node_modules/swiper/swiper.css");
    options = Object.assign(options, {
      modules: [Navigation, Autoplay],
      navigation: {
        nextEl: `${swiperSelectorString} .swiper-button-next`,
        prevEl: `${swiperSelectorString} .swiper-button-prev`,
      },
    });
    // await import("/node_modules/swiper/modules/navigation.css");
    console.log({ swiperCollection });
    swiperCollection.forEach((swiper, i) => {
      console.log(`${swiper} img`);
      const image = swiper.querySelector(`img`);
      const li = swiper.querySelector(`li`);
      const liHeight = swiper.scrollHeight;
      const caption = swiper.querySelector(`.caption`);
      // console.log(
      //     image.scrollHeight,
      //     caption.getBoundingClientRect().height,
      // );
      const imageHeight = liHeight - caption?.getBoundingClientRect().height;
      const navigator = swiper.querySelector(".swiper-nav");
      // console.log({
      //     swiper,
      //     image,
      //     navigator,
      //     caption,
      //     swiper,
      //     imageHeight,
      // });
      // navigator.style.bottom = `${imageHeight}px`;
      const cards = Array.from(swiper.querySelectorAll(".card"));
      const wrapper = swiper.querySelector(".swiper-wrapper");
      console.log(cards.length);
      if (cards.length && cards.length < 5) {
        let counter = 1;
        let childLength = document
          .querySelectorAll(swiperSelectorString)
          [i]?.querySelector(".swiper-wrapper").childElementCount;

        while (childLength < 10) {
          console.log(cards);
          const clonedElement = cards[counter - 1].cloneNode(true);
          clonedElement.setAttribute("aria-hidden", "true");
          wrapper.appendChild(clonedElement);
          childLength = document
            .querySelectorAll(swiperSelectorString)
            [i]?.querySelector(".swiper-wrapper").childElementCount;

          if (counter == cards.length) {
            counter = 1;
          } else {
            counter++;
          }
        }
      }
      swiper = swiper.parentElement.querySelector(".swiper");
      console.log(swiper.querySelector(".swiper-wrapper").childElementCount);
      const swiperInstance = new Swiper(swiper, options);
      console.log(swiperInstance);
    });
  }
}

export default initializeSwiper;
